import { RequestHelper } from "./RequestHelper";
import { LocalStorageHelper } from "../lib/LocalStorageHelper";
import { Common } from "../lib/Common";

class BaseApi {
    domain = "";
    baseUrl = "";
    token = "";
    countryCode = "";
    customerNumber = "";

    constructor(_domain) {
        this.domain = _domain;
        this.getCustomerValues();
    }

    setBaseUrl(path) {
        this.baseUrl = `${this.domain}/${path}`;
    }

    getCustomerValues() {
        var access = LocalStorageHelper.getAccess();

        this.token = access?.access_token;

        const languageCode = Common.getLanguageCode();

        this.countryCode = LocalStorageHelper.getLoggedInUserCountryCode() ?? languageCode.substring(languageCode.indexOf('-') + 1);

        this.customerNumber = LocalStorageHelper.isBusinessUser()
            ? LocalStorageHelper.getLoggedInBusinessUser()?.customerNumber
            : null;
    }

    getSecurityHeader = () => {
        return {
            "Authorization": "Bearer " + this.token,
            "Content-Type": "application/json",
            // "x-Gateway-APIKey": process.env.REACT_APP_WM_API_GW_KEY,
            "x-country-iso": this.countryCode
        };
    }

    _getRequestHelper(path) {
        var helper = new RequestHelper(this.baseUrl)

        if (this.token != null) {
            var headers = this.getSecurityHeader();
            helper.withHeaders(headers);
        }

        return helper.withPath(path)
    }

    _createStandardPromiseRequest(path) {
        var helper = this._getRequestHelper(path);

        return helper.usingPromise();
    }

    _createStandardRequest(path, callback, onError) {
        var helper = this._getRequestHelper(path);

        return helper
            .usingCallback(callback)
            .usingErrorHandling(onError);
    }
}

export default BaseApi;